export enum SERVICES {
  MYACCOUNT = 'myaccount',
  MY_ACCOUNT = 'my-account',
  CONTROL = 'control',
}
